import {resolveBackground, resolveBorderColor} from '#core/utils/color-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';

export function matchAccaFactory(PALETTE) {
    return {
        MatchAccaButton: {
            style: {
                container: {
                    ...resolveBackground(PALETTE.MATCH_ACCA_SELECTIONS_BAR_BG),
                    ...generateBorder(PALETTE.MATCH_ACCA_SELECTIONS_BAR_BORDER),
                    // the height of container should be lower than button height, because in compact view, button is highlighted by container
                    height: 46,
                    position: 'relative',
                    widthWithOddsCalculation: 120,
                },
                oddsContainer: {
                    padding: '8px 0 0 4px',
                },
                textLabel: {
                    fontSize: 11,
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_ODDS_LABEL_TEXT,
                },
                valueLabel: {
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_ODDS_VALUE_TEXT,
                },
                errorLabel: {
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_ODDS_ERROR_VALUE_TEXT,
                },
                selectionCountContainer: {
                    ...resolveBackground(PALETTE.MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_BG),
                    ...resolveBorderColor(PALETTE.MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_BG),
                    borderRadius: '50%',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    height: 48,
                    right: -1,
                    top: -2,
                    width: 48,
                },
                selectionCountLabel: {
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_TEXT,
                },
            },
        },
    };
}
